<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Finance/check.html')">财务管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>账单列表</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="状态">
				<el-select v-model="item.state" placeholder="请选择状态" size="small">
					<el-option label="全部" value="0"></el-option>
					<el-option label="待平台审核" value="2"></el-option>
					<el-option label="平台已审核" value="3"></el-option>
					<el-option label="已完成" value="4"></el-option>
					<el-option label="已驳回" value="10"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="时间">
				<el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="daterange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
				<el-button type="success" @click="excelOut" size="medium">导出</el-button>
				<el-button type="primary" @click="createBill" size="medium" v-auth="['supplier/finance/createOrderbill']">生成对账单</el-button>
				<el-button type="primary" @click="downloadFile()" size="medium">下载付款申请通知模板</el-button>
			</el-form-item>
		</el-form>
		<!--		数据是list 通过list展示-->
		<el-table :data="list" border>
			<el-table-column prop="id" label="ID" width="90"></el-table-column>
			<el-table-column prop="order_total" label="订单金额" width="120"></el-table-column>
			<el-table-column prop="order_count" label="订单数量" width="90"></el-table-column>
			<el-table-column prop="express_total" label="运费金额" width="120"></el-table-column>
			<el-table-column prop="refund_total" label="退款金额" width="120"></el-table-column>
			<el-table-column prop="result_totals" label="应结金额" width="120"></el-table-column>
			<el-table-column label="状态" width="120">
				<template slot-scope="scope">
					<span v-if="scope.row.state == 2">待平台审核</span>
					<span v-if="scope.row.state == 3">待平台结算</span>
					<span v-if="scope.row.state == 4">已完成</span>
					<span v-if="scope.row.state == 0">已驳回</span>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="时间"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="view(scope.row.id)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {},
			}
		},
		created() {
			this.item = {
				page: this.page,
				limit: this.pageSize
			}
			this.loadList()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			loadList() {
				this.isLoad = !this.isLoad
				this.axios.get('supplier/Finance/index',{params:{
						page:this.page,
						limit:this.pageSize,
						state:this.item.state,
						times:this.item.times
					}}).then(res => {
					this.isLoad = false
					this.list = res.data.list.data
					this.total = res.data.list.total
				}).catch(() => {
					this.isLoad = false
				})
			},
			// 跳转到edit添加
			add() {
				return
				this.$router.push({
					path: '/Member/MemberLevelEdit.html'
				});
			},
			look(id) {
				this.$router.push({
					path: '/Finance/detail.html',
					query: {
						id: id
					}
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			end(id) {
				this.$router.push({
					path: '/Finance/endStatement.html',
					query: {
						id: id
					}
				});
			},
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				if (this.isLoad) {
					return false
				}

				this.isLoad = !this.isLoad
				setTimeout(function () {
					this.isLoad = false
				}.bind(this), 100000);
				this.axios.post('/supplier/finance/listExport', this.item)
						.then(res => {
							this.isLoad = false
							if (res.code == 1) {
								import('@/vendor/Export2Excel.js').then(excel => {
									var expCellName = res.data.expCellName
									var tHeader = []
									var filterVal = []
									for (var i in expCellName) {
										tHeader.push(expCellName[i])
										filterVal.push(i)
									}
									const expTableData = res.data.expTableData
									const data = this.formatJson(filterVal, expTableData)
									var d = new Date()
									var year = d.getFullYear()
									var month = d.getMonth()
									var date = d.getDate()
									var hour = d.getHours()
									var minute = d.getMinutes()
									var second = d.getSeconds()
									month = month < 10 ? '0' + month : month
									date = date < 10 ? '0' + date : date
									hour = hour < 10 ? '0' + hour : hour
									minute = minute < 10 ? '0' + minute : minute
									second = second < 10 ? '0' + second : second
									excel.export_json_to_excel({
										header: tHeader,
										data,
										filename: '商家对账单导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
										autoWidth: this.autoWidth,
										bookType: this.bookType
									})
								})
							} else {
								this.$message({
									message: res.msg,
									type: 'error',
									duration: 3 * 1000
								})
							}
						})
			},
			formatJson (filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => {
					return v[j]
				}))
			},
			createBill: function () {
				this.$router.push({
					path: '/Finance/createbill.html',
					query: {
					}
				});
			},
			view(id) {
				this.$router.push({
					path: '/finance/detail.html',
					query: {
						id: id,
					}
				});
			},
			downloadFile() {
				window.open('https://supply.oss.xm0592.com/orderpay_apply.docx')
			},
		},

	}
</script>
<style scoped>
</style>
